module.exports = __webpack_public_path__ + "assets/img/youxiu01.e0715a3f.png";